import { createSelector } from 'reselect';
import getModuleState from './moduleStateSelector';

export const getRequest = createSelector(
  getModuleState,
  (state) => state.get('request')
);

export const getRequestAsJS = createSelector(
  getRequest,
  (request) => request.toJS()
);

export const getLocation = createSelector(
  getRequest,
  (state) => state.get('location').toJS()
);

export const getLocationId = createSelector(
  getLocation,
  (location) => location?.id
);

export const getLocationQuery = createSelector(
  getLocation,
  (location) => location?.query
);

export const getLocationName = createSelector(
  getLocation,
  (location) => location?.name
);

export const getRooms = createSelector(
  getRequest,
  (state) => state.get('rooms').toJS()
);

export const getDates = createSelector(
  getRequest,
  (state) => ({
    startDate: state.get('startDate'),
    endDate: state.get('endDate'),
  })
);
